"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageMetadataOrDefault = exports.pageLinksOrDefault = exports.toMetricsInfo = exports.spotlightStoryMetadataOrDefault = exports.viewerInfoOrDefault = exports.DEFAULT_USER_DISPLAY_INFO = exports.DEFAULT_NOT_AVAILABLE_METADATA = exports.DEFAULT_NOT_FOUND_METADATA = exports.DEFAULT_PAGE_LINKS = exports.DEFAULT_LOCALIZATION = exports.DEFAULT_SPOTLIGHT_STORY_METADATA = exports.DEFAULT_VIEWER_INFO = exports.DEFAULT_ONE_LINK = void 0;
const common_1 = require("@snapchat/content-platform-www/generated-src/snapchat/web/stories/common");
exports.DEFAULT_ONE_LINK = "https://click.snapchat.com/aVHG?pid=snapchat_download_page&af_dp=https://link.snapchat.com/unlock&af_web_dp=https://www.snapchat.com/download&purpose=web_stories";
exports.DEFAULT_VIEWER_INFO = {
    country: "ZZ",
    locale: "en",
    // DEFAULT value of GDPR country is true, so that we don't add GA for 404 pages
    isGdprCountry: true,
};
exports.DEFAULT_SPOTLIGHT_STORY_METADATA = {
    hashtags: [],
    lensMetadata: undefined,
    userMetadata: undefined,
    videoMetadata: undefined,
    contextCards: [],
    engagementStats: undefined,
    deeplink: "",
    description: "",
    oneLinkParams: undefined,
};
exports.DEFAULT_LOCALIZATION = {
    direction: common_1.LanguageDirection.AUTO,
};
exports.DEFAULT_PAGE_LINKS = {
    oneLinkUrl: exports.DEFAULT_ONE_LINK,
    snapchatCanonicalUrl: "https://link.snapchat.com/unlock",
    canonicalUrl: "https://www.snapchat.com",
    snapcodeImageUrl: "",
    downloadUrl: "https://www.snapchat.com/download/",
    oneLinkParams: undefined,
    snapchatDeepLinkUrl: "https://link.snapchat.com/unlock",
};
exports.DEFAULT_NOT_FOUND_METADATA = {
    pageType: common_1.PageType.NOT_FOUND,
    pageTitle: "Snapchat",
    pageDescription: undefined,
    shareId: "",
};
exports.DEFAULT_NOT_AVAILABLE_METADATA = {
    pageType: common_1.PageType.NOT_AVAILABLE,
    pageTitle: "Snapchat",
    pageDescription: undefined,
    shareId: "",
};
exports.DEFAULT_USER_DISPLAY_INFO = {
    displayName: "",
    emoji: "",
    hasBadge: false,
    profilePictureUrl: "",
    username: "",
};
/**
 *
 */
function viewerInfoOrDefault(viewerInfo) {
    if (viewerInfo)
        return viewerInfo;
    else
        return exports.DEFAULT_VIEWER_INFO;
}
exports.viewerInfoOrDefault = viewerInfoOrDefault;
/**
 *
 */
function spotlightStoryMetadataOrDefault(storyMetadata) {
    if (storyMetadata)
        return storyMetadata;
    else
        return exports.DEFAULT_SPOTLIGHT_STORY_METADATA;
}
exports.spotlightStoryMetadataOrDefault = spotlightStoryMetadataOrDefault;
/**
 *
 */
function toMetricsInfo(props) {
    const viewerInfo = viewerInfoOrDefault(props.viewerInfo);
    return {
        country: viewerInfo.country,
    };
}
exports.toMetricsInfo = toMetricsInfo;
/**
 *
 */
function pageLinksOrDefault(pageLinks) {
    if (pageLinks)
        return pageLinks;
    else
        return exports.DEFAULT_PAGE_LINKS;
}
exports.pageLinksOrDefault = pageLinksOrDefault;
/**
 *
 */
function pageMetadataOrDefault(pageMetadata) {
    if (pageMetadata)
        return pageMetadata;
    else
        return exports.DEFAULT_NOT_FOUND_METADATA;
}
exports.pageMetadataOrDefault = pageMetadataOrDefault;
//# sourceMappingURL=fallbacks.js.map